// B2 - Ünite 2: Past Continuous
// Hedef: Was/Were + -ing, while vs when

export const B2_UNIT_2 = {
  'B2-U2-L1': {
    id: 'B2-U2-L1',
    title: 'Was/Were + fiil-ing',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Past Continuous Tense',
          explanation: 'Geçmişte belirli bir anda devam etmekte olan eylemler için kullanılır. Was/Were + fiil-ing',
          table: {
            headers: ['Şahıs', 'Yapı', 'Örnek'],
            rows: [
              ['I/He/She/It', 'was + -ing', 'I was working at 9 PM.'],
              ['You/We/They', 'were + -ing', 'They were sleeping.'],
              ['Olumsuz', 'was/were not + -ing', 'She wasn\'t listening.'],
              ['Soru', 'Was/Were + subject + -ing?', 'Were you working?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['The passengers were boarding when the alarm went off.', 'Alarm çaldığında yolcular biniyordu.'],
              ['I was serving drinks when the turbulence started.', 'Türbülans başladığında içecek servis ediyordum.'],
              ['The captain was making an announcement.', 'Kaptan anons yapıyordu.'],
              ['We were preparing for landing.', 'İnişe hazırlanıyorduk.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Past Continuous = Geçmişte devam eden eylem | "At 9 PM yesterday, I was..."'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'At 9 PM, I _____ dinner.',
          options: ['was having', 'were having', 'had', 'have'],
          correct: 'was having',
          explanation: 'I + was + -ing'
        },
        {
          type: 'multipleChoice',
          question: 'They _____ when I arrived.',
          options: ['were sleeping', 'was sleeping', 'slept', 'sleep'],
          correct: 'were sleeping',
          explanation: 'They + were + -ing'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['serving', 'was', 'I', 'drinks'],
          correctOrder: [2, 1, 0, 3],
          translation: 'İçecek servis ediyordum.'
        },
        {
          type: 'flashcard',
          title: '🎴 Past Continuous Kalıpları',
          cards: [
            { front: 'I was working', back: 'Çalışıyordum' },
            { front: 'She was sleeping', back: 'Uyuyordu' },
            { front: 'They were waiting', back: 'Bekliyorlardı' },
            { front: 'We were flying', back: 'Uçuyorduk' }
          ]
        }
      ]
    }
  },
  'B2-U2-L2': {
    id: 'B2-U2-L2',
    title: 'While vs When',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 While vs When',
          table: {
            headers: ['While', 'When'],
            rows: [
              ['Uzun eylem (Past Continuous)', 'Kısa eylem (Past Simple)'],
              ['While I was sleeping...', 'When the phone rang...'],
              ['Devam eden eylem', 'Anlık eylem, kesinti']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Örnek Cümleler',
          table: {
            headers: ['Cümle', 'Analiz'],
            rows: [
              ['While I was serving, the turbulence started.', 'Uzun eylem + kısa kesinti'],
              ['When the alarm rang, we were boarding.', 'Kısa eylem + devam eden'],
              ['While they were sleeping, the plane landed.', 'Uzun + kısa'],
              ['I was reading when the captain made an announcement.', 'Devam eden + kesinti']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 WHILE + Past Continuous (uzun) | WHEN + Past Simple (kısa/kesinti)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ I was sleeping, the phone rang.',
          options: ['While', 'When', 'During', 'As soon as'],
          correct: 'While',
          explanation: 'While + Past Continuous'
        },
        {
          type: 'multipleChoice',
          question: 'I was reading _____ the captain made an announcement.',
          options: ['when', 'while', 'during', 'as'],
          correct: 'when',
          explanation: 'When + Past Simple (kesinti)'
        },
        {
          type: 'timeRace',
          title: '⏱️ While mi When mi?',
          cards: [
            { front: '___ I was sleeping, (phone rang)', back: 'While' },
            { front: 'I was working ___ he arrived', back: 'when' },
            { front: '___ they were eating, (power went out)', back: 'While' },
            { front: 'She called ___ I was cooking', back: 'while' }
          ]
        }
      ]
    }
  },
  'B2-U2-L3': {
    id: 'B2-U2-L3',
    title: 'Past Continuous vs Past Simple',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Karşılaştırma',
          table: {
            headers: ['Past Continuous', 'Past Simple'],
            rows: [
              ['Devam eden eylem', 'Tamamlanmış eylem'],
              ['I was working at 9.', 'I worked yesterday.'],
              ['Arka plan bilgisi', 'Ana olaylar'],
              ['"What were you doing?"', '"What did you do?"']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Hikaye Anlatımı',
          explanation: 'Past Continuous arka plan için, Past Simple ana olaylar için kullanılır.',
          table: {
            headers: ['Arka Plan (P. Cont.)', 'Ana Olay (P. Simple)'],
            rows: [
              ['The sun was shining.', 'The plane took off.'],
              ['Passengers were relaxing.', 'Turbulence hit.'],
              ['I was serving drinks.', 'A passenger fainted.']
            ]
          }
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'At 9 PM yesterday, I _____ TV.',
          options: ['was watching', 'watched', 'watch', 'am watching'],
          correct: 'was watching',
          explanation: 'Belirli bir anda devam eden → Past Continuous'
        },
        {
          type: 'multipleChoice',
          question: 'I _____ TV last night.',
          options: ['watched', 'was watching', 'watch', 'am watching'],
          correct: 'watched',
          explanation: 'Tamamlanmış eylem → Past Simple'
        },
        {
          type: 'fillInBlank',
          sentence: 'While I _____ (sleep), the phone _____ (ring).',
          answer: 'was sleeping, rang',
          hint: 'While + Past Continuous, Past Simple'
        }
      ]
    }
  },
  'B2-U2-L4': {
    id: 'B2-U2-L4',
    title: 'Interrupted Actions',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Kesintiye Uğrayan Eylemler',
          explanation: 'Devam eden bir eylem başka bir eylemle kesildiğinde bu yapı kullanılır.',
          table: {
            headers: ['Devam Eden', 'Kesinti', 'Tam Cümle'],
            rows: [
              ['I was serving drinks', 'turbulence started', 'I was serving drinks when turbulence started.'],
              ['She was sleeping', 'the alarm rang', 'She was sleeping when the alarm rang.'],
              ['We were boarding', 'the announcement came', 'We were boarding when the announcement came.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '✈️ Havacılık Kesinti Senaryoları',
          words: [
            { en: 'I was checking passports when the system crashed.', tr: 'Pasaportları kontrol ediyordum, sistem çöktü.', pronunciation: '' },
            { en: 'We were preparing for takeoff when the delay was announced.', tr: 'Kalkışa hazırlanıyorduk, gecikme duyuruldu.', pronunciation: '' },
            { en: 'The passengers were boarding when the fire alarm went off.', tr: 'Yolcular biniyordu, yangın alarmı çaldı.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ lunch when my phone _____.',
          options: ['was having / rang', 'had / was ringing', 'was having / was ringing', 'had / rang'],
          correct: 'was having / rang',
          explanation: 'Devam eden (P.Cont.) + Kesinti (P.Simple)'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['sleeping', 'was', 'rang', 'I', 'when', 'the', 'alarm'],
          correctOrder: [3, 1, 0, 4, 5, 6, 2],
          translation: 'Alarm çaldığında uyuyordum.'
        }
      ]
    }
  },
  'B2-U2-L5': {
    id: 'B2-U2-L5',
    title: 'Uygulama: Olay Raporu',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📝 Olay Raporu Yazma',
          explanation: 'Olayları rapor ederken Past Continuous arka plan, Past Simple ana olaylar için kullanılır.',
          table: {
            headers: ['Rapor Bölümü', 'Zaman', 'Örnek'],
            rows: [
              ['Arka plan', 'Past Continuous', 'The flight was proceeding normally.'],
              ['Ana olay', 'Past Simple', 'A passenger suddenly felt unwell.'],
              ['Tepki', 'Past Simple', 'I immediately called for assistance.'],
              ['Sonuç', 'Past Simple', 'Medical staff attended to the passenger.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '📝 Örnek Rapor',
          words: [
            { en: 'At approximately 14:30, the flight was cruising at 35,000 feet.', tr: 'Yaklaşık 14:30\'da uçuş 35.000 fitte seyir halindeydi.', pronunciation: '' },
            { en: 'Passengers were relaxing when turbulence occurred.', tr: 'Türbülans olduğunda yolcular dinleniyordu.', pronunciation: '' },
            { en: 'I was serving in row 15 when I heard a loud noise.', tr: '15. sırada servis yapıyordum, yüksek bir ses duydum.', pronunciation: '' },
            { en: 'I immediately secured the cabin and informed the captain.', tr: 'Hemen kabini güvence altına aldım ve kaptana bilgi verdim.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu rapor cümlelerini sesli okuyun:',
          phrases: [
            'The flight was proceeding normally.',
            'I was serving drinks when the incident occurred.',
            'The passenger was sleeping when the turbulence started.',
            'I immediately informed the captain.'
          ]
        }
      ]
    }
  },
  'B2-U2-EXAM': {
    id: 'B2-U2-EXAM',
    title: 'Ünite 2 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'At 9 PM, I _____ TV.',
        options: ['was watching', 'watched', 'watch', 'am watching'],
        correct: 'was watching',
        explanation: 'Belirli anda devam eden → Past Continuous'
      },
      {
        type: 'multipleChoice',
        question: '_____ I was cooking, the phone rang.',
        options: ['While', 'When', 'During', 'As soon as'],
        correct: 'While',
        explanation: 'While + Past Continuous'
      },
      {
        type: 'multipleChoice',
        question: 'I was reading _____ he arrived.',
        options: ['when', 'while', 'during', 'as'],
        correct: 'when',
        explanation: 'When + Past Simple (kesinti)'
      },
      {
        type: 'multipleChoice',
        question: 'They _____ dinner when I called.',
        options: ['were having', 'had', 'have', 'are having'],
        correct: 'were having',
        explanation: 'Devam eden eylem → Past Continuous'
      },
      {
        type: 'fillInBlank',
        sentence: 'The passengers _____ (board) when the alarm went off.',
        answer: 'were boarding',
        hint: 'Devam eden → were + -ing'
      },
      {
        type: 'matchPairs',
        instruction: 'Eşleştirin',
        pairs: [
          { left: 'While', right: 'Past Continuous' },
          { left: 'When (kesinti)', right: 'Past Simple' },
          { left: 'At 9 PM', right: 'Past Continuous' },
          { left: 'Yesterday', right: 'Past Simple' }
        ]
      }
    ]
  }
};

export default B2_UNIT_2;
